import { HTTPError, TimeoutError } from "ky";

/** Normalize an API error into a human-readable message. */
export async function normalizeError(error: Error): Promise<string> {
  let message = error.message;
  if (error instanceof TimeoutError) {
    message = "Network error: " + error.message;
  } else if (error instanceof HTTPError) {
    try {
      // Server errors have a JSON payload from Sanic. Network errors are not `HTTPError`.
      const payload: {
        description: string;
        status: number;
        message: string;
      } = await error.response.json();
      message = payload.description;
      if (payload.message && payload.message !== "None") {
        message += ": " + payload.message;
      }
    } catch (_) {
      // GoogleBot returns 499 for /api endpoints which don't have valid JSON responses.
      return message;
    }
  }
  return message;
}
